import { GuveryPaper } from '#root/ui-components/cards';
import styles from './walletBalanceCard.module.scss';

interface WalletBalanceCardProps {
  saldo: string | null;
  saldoEstado: number | null;
  saldoEvento: string | null;
}

const WalletBalanceCard = ({ saldo, saldoEstado, saldoEvento }: WalletBalanceCardProps) => {
  const saldoNum = parseFloat(saldo ?? '0');

  return (
    <GuveryPaper disableElevation disableHover>
      <div className={styles.cardWallet}>
        {saldoEstado === 1 ? (
          <>
            <h4>
              <small>USD</small><span>{saldo}</span>
            </h4>
            {saldoNum < 0 && saldoEvento === 'ENVIO_ACTUALIZADO' && (
              <p className={styles.balanceEvent}>(envío actualizado)</p>
            )}
            {saldoNum < 0 && saldoEvento === 'ACUERDO_MODIFICADO' && (
              <p className={styles.balanceEvent}>(pedido actualizado)</p>
            )}
            {saldoNum > 0 && (
              <>
                <p className={`${styles.balanceMessage} ${styles.positive}`}>
                  El saldo a tu favor <strong>jamás expira</strong> y estará disponible para ti{' '}
                  <strong>por siempre</strong>.
                </p>
                <p className={`${styles.balanceSubMessage} ${styles.positive}`}>
                  Puedes usarlo para pagar ó puedes solicitar un reembolso en cualquier momento.
                </p>
              </>
            )}
          </>
        ) : (
          <h6>En proceso...</h6>
        )}
      </div>
    </GuveryPaper>
  );
};

export default WalletBalanceCard;
